import axios from 'axios';
import { API_URL } from '@/config.js';
import store from '@/store'; // Import the store instance

const axiosInstance = axios.create({
  baseURL: API_URL,
  timeout: 120000, // 120 seconds (2 minutes) - for long-running article generation requests
  // Other default configurations
});

axiosInstance.interceptors.request.use(
  (config) => {
    const urlParams = new URLSearchParams(window.location.search);

    let chatbot_name = urlParams.get('chatbot_name');

    // If chatbot_name not in URL, detect from domain
    if (!chatbot_name) {
      const hostname = window.location.hostname;
      if (hostname.includes('meetscribe')) {
        chatbot_name = 'meetscribe';
      } else if (hostname.includes('clipcut')) {
        chatbot_name = 'clipcut';
      } else if (hostname.includes('narezkavideo')) {
        chatbot_name = 'narezkavideo';
      } else if (hostname.includes('harikatha')) {
        chatbot_name = 'harikatha';
      } else if (hostname.includes('chaitanyaacademy')) {
        chatbot_name = 'chaitanyaacademy';
      } else if (hostname.includes('vid2text') || hostname.includes('video2text')) {
        chatbot_name = 'vid2text';
      } else if (hostname.includes('youtest')) {
        chatbot_name = 'vid2text'; // youtest.ru uses vid2text bot
      }
    }

    const authToken = localStorage.getItem('authToken');
    config.headers['Authorization'] = `Bearer ${authToken}`;
    //const urlParams = new URLSearchParams(window.location.search);
    const hash = store.getters['hash/getHash']; // Access the hash value from the hashModule using store getters
    if (hash) {
      config.params = {
        ...config.params,
        hash: hash,
      };
    }
    // Don't send auto-detected chatbot_name for get_config_data - it disables Telegram auth
    const isConfigRequest = config.params?.action === 'get_config_data';
    if (chatbot_name && !isConfigRequest) {
      config.params = {
        ...config.params,
        chatbot_name: chatbot_name,
      };
    }

    // Add user's locale/language preference for backend localization
    const userLocale = localStorage.getItem('user-locale') || 'ru';
    config.params = {
      ...config.params,
      lang: userLocale,
    };

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Helper function to handle logout on auth failure
const handleAuthFailure = () => {
  // Prevent redirect loop - only act if we have a token to remove
  const hadToken = localStorage.getItem('authToken');
  if (!hadToken) {
    // Already logged out, don't redirect again
    return;
  }

  console.warn('Auth failure - logging out user');

  // Clear auth state
  store.commit('user/setAuthentication', false);
  store.commit('user/setUser', null);

  // Remove invalid token from localStorage
  localStorage.removeItem('authToken');

  // Reload page once to show login state (no redirect loop because token is now gone)
  window.location.reload();
};

axiosInstance.interceptors.response.use(
  (response) => {
    // Check for auth errors in response body (some endpoints return 200 with error)
    const data = response.data;

    // Skip auth check for public endpoints
    const url = response.config?.url || '';
    const isPublicEndpoint = url.includes('get_config_data') ||
                              url.includes('action=login') ||
                              url.includes('action=get_article');

    if (!isPublicEndpoint) {
      if (data && data.error === 'Auth required') {
        handleAuthFailure();
        return Promise.reject(new Error('Auth required'));
      }
      if (data && data.error === 'Invalid or expired token') {
        handleAuthFailure();
        return Promise.reject(new Error('Invalid or expired token'));
      }
    }
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      handleAuthFailure();
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
